import { Component, ElementRef, inject, viewChild, ChangeDetectionStrategy } from "@angular/core";
import { NgOtpInputComponent } from "ng-otp-input";
import { FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { lastValueFrom } from "rxjs";

import { LoadingDialogService } from "@shared/services/loading-dialog/loading-dialog.service";
import { CheckoutService } from "@data/services/checkout/checkout.service";
import { HttpOptions } from "@shared/services/base/models";
import { encrypt } from "@utils/encrypt/encrypt";
import { AnalyticsService } from "@shared/services/analytics/analytics.service";

@Component({
  selector: "app-otp",
  templateUrl: "./otp.component.html",
  styleUrls: ["./otp.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgOtpInputComponent, ReactiveFormsModule],
})
export class OtpComponent {
  private readonly analyticsService = inject(AnalyticsService);

  private readonly loadingDialogService = inject(LoadingDialogService);

  private readonly checkoutService = inject(CheckoutService);

  private button = viewChild<ElementRef<HTMLButtonElement>>("button");

  private readonly router = inject(Router);

  private readonly route = inject(ActivatedRoute);

  readonly MAX_OTP_LENGTH = 5;

  private id = this.route.snapshot.paramMap.get("id");

  otpControl = new FormControl("", [
    Validators.required,
    Validators.minLength(this.MAX_OTP_LENGTH),
    Validators.maxLength(this.MAX_OTP_LENGTH),
  ]);

  // The OTP value is set on otpControl by ng-otp-input (ControlValueAccessor)
  focusWhenFilled(e: string | null) {
    if (e?.length === this.MAX_OTP_LENGTH) {
      setTimeout(() => {
        this.button()?.nativeElement?.focus();
      }, 100);
    }
  }

  async save(e: any) {
    e.preventDefault();
    const value = this.otpControl.value;

    if (value?.length !== this.MAX_OTP_LENGTH) {
      return;
    }

    this.loadingDialogService.show();

    try {
      const options: HttpOptions = {
        headers: {
          "vs-auth-hash": encrypt(value),
        },
      };

      const res = await lastValueFrom(
        this.checkoutService.getById(`check-renewal/${this.id}`, options),
      );

      this.analyticsService.user.next(res.data?.customer);
      await this.router.navigateByUrl(`/renovacao/${this.id}/metodo-de-pagamento`, {
        state: {
          user: res,
        },
      });
      this.loadingDialogService.close();
    } catch (err: any) {
      this.otpControl.setErrors({ custom: err?.app_meta?.message || err?.message });
      this.loadingDialogService.close();
    }
  }
}
